import { LineGraphConfigBlockState } from './types';

const defaultState: LineGraphConfigBlockState = {
    settings: {
        title: '',
        fontSize: 100,
        items: [],
        timeStepsPerDay: 2,
        offsetLeft: 50,
        useFixedOffset: true,
        subTitle: 'possible day range',
        description: '',
        legendPosition: 'top',
        enableXAxis: true,
        enableYAxis: true,
        legendFullWidth: false,
        truncateNowTo: 'day',
        canDownload: false,
    },
    databilities: [],
};

export default defaultState;
